<nav
  class="block bg-white border-r border-sonic-silver border-solid h-full w-full"
>
  @if (sidebarVoices.length) {
  <ul class="w-full">
    @for (voice of sidebarVoices; track $index) {
    <li class="flex items-center w-full">
      <div
        class="w-[5px] h-[50px]"
        [ngClass]="{
                'bg-white': !voice.isActive,
                'bg-crayola': voice.isActive,
              }"
      ></div>
      <a
        (click)="voiceSelect(voice.url)"
        class="flex items-center cursor-pointer w-full h-[50px] tracking-wider"
        [ngClass]="{
          'bg-[#0048c11a] text-crayola': voice.isActive,
          'bg-white text-arsenic': !voice.isActive
        }"
        [title]="voice.title || voice.label"
      >
        <span class="block mx-4 text-base font-bold">{{ voice.label }}</span>
        @if($any(voice)?.hasIcon) {
        <img [src]="$any(voice)?.iconUrl" alt="error icon" class="w-4 h-4" />
        }
      </a>
    </li>
    }
  </ul>
  }
</nav>
